import type { QueryHookOptions } from "@apollo/client";
import { useQuery } from "@apollo/client";
import {
  ClientFindPastWorkersDocument,
  type ClientFindPastWorkersQuery,
  type ClientFindPastWorkersQueryVariables,
} from "@/__generated__/graphql";
import { fullName } from "@/lib/helpers/string";

export const mapPastWorkerDetail = (
  worker: ClientFindPastWorkersQuery["clientFindPastWorkersV2"]["workers"][number],
) => ({
  id: worker.id,
  fullName: fullName({
    firstName: worker.firstName,
    lastName: worker.lastName,
  }),
  phoneNumber: worker.contactNumber ?? null,
  avatarUrl: worker.avatarUrl ?? null,
  workerRating: worker.workerRating,
  recentCompletedVisitsInMonth: worker.totalRecentCompletedVisits ?? 0,
});

export const useClientPastWorkersQuery = (
  options: QueryHookOptions<
    ClientFindPastWorkersQuery,
    ClientFindPastWorkersQueryVariables
  >,
) => {
  const result = useQuery(ClientFindPastWorkersDocument, options);

  const workers =
    result.data?.clientFindPastWorkersV2.workers.map(mapPastWorkerDetail) ?? [];

  return {
    count: result.data?.clientFindPastWorkersV2?.count ?? 0,
    workers,
    ...result,
  };
};
